import React from "react";

/* =========================================================
   Skeleton
   Lightweight shimmer placeholder used while data is loading.

   <Skeleton height={16} width="60%" />
   <Skeleton.Table rows={5} cols={4} />
   <Skeleton.Card />
========================================================= */
function Skeleton({ height = 14, width = "100%", radius = 8, style = {} }) {
  return (
    <div
      className="skeleton-block"
      style={{ height, width, borderRadius: radius, ...style }}
    />
  );
}

Skeleton.Table = function SkeletonTable({ rows = 5, cols = 4 }) {
  return (
    <div className="skeleton-table">
      {Array.from({ length: rows }).map((_, r) => (
        <div className="skeleton-row" key={r}>
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton key={c} height={14} width={c === 0 ? "20%" : "100%"} />
          ))}
        </div>
      ))}
    </div>
  );
};

Skeleton.Card = function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <Skeleton height={18} width="40%" />
      <Skeleton height={30} width="60%" style={{ marginTop: 12 }} />
      <Skeleton height={10} width="90%" style={{ marginTop: 16 }} />
    </div>
  );
};

export default Skeleton;
